import type { StockItem } from "./types";

// Client-side mirror of packages/db/sql/functions/inventory/stock_to_base_qty.sql,
// shared by the recipe editor, receipts and counts. The server stays the
// source of truth and validates every unit.

const FIXED: Record<string, Record<string, number>> = {
  g: { kg: 1000, mg: 0.001 },
  ml: { l: 1000, dl: 100, cl: 10 },
  piece: {},
};

/** Units a recipe line can use for this item: base, its own units, fixed ones. */
export function unitOptions(item: StockItem): string[] {
  return [
    item.base_unit,
    ...item.units.map((u) => u.name),
    ...Object.keys(FIXED[item.base_unit] ?? {}),
  ];
}

/** Quantity in the item's base unit, or null if the unit can't convert. */
export function toBaseQty(item: StockItem, qty: number, unit: string): number | null {
  const u = unit.trim().toLowerCase();
  if (u === item.base_unit) return qty;
  const own = item.units.find((x) => x.name.toLowerCase() === u);
  if (own) return qty * own.base_qty;
  const factor = FIXED[item.base_unit]?.[u];
  return factor == null ? null : qty * factor;
}
